/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-11 17:30:22 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-11 17:32:46
 */
import { fetchTool } from '@/common/index'
import api from "./api";


let fetchObj = {}

fetchObj.baseLookupTypeService_find = (params) => fetchTool.post(api.baseLookupTypeService_find, params)

export default fetchObj


// WEBPACK FOOTER //
// ./src/page/demo/config/fetchData.js